import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from '@ngx-ivengi/locale';

@Injectable()
export class AppConfigService {
  private static domainSettings: any;

  constructor(
    private translate: TranslateService,
  ) {
  }

  public initializeApp(): void {
    this.setTranslateConfig();
  }

  private setTranslateConfig(): void {
    this.translate.setDefaultLang(LocaleService.getDefaultLanguageISO());
    this.translate.use(LocaleService.getCurrentLanguageISO());
  }

  public static setDomainSettings(domainSettings: any) {
    this.domainSettings = domainSettings;
  }

  public static getDomainSettings() {
    return this.domainSettings;
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/app.config.service.ts